import { lazy } from "react";
import IRoute from "./IRoute";

const ViewBlogPage = lazy(() => import("../pages/Blog/ViewBlogPage"));

const blogRoutes: IRoute = {
  path: "/blog",
  redirect: "/blog/view",
  children: [
    {
      path: "/view",
      component: ViewBlogPage,
      needAuth: true,
    },
  ],
};

export default blogRoutes;
